import {
  FeatureFlagsContext,
  FeatureFlagsContextType,
} from '@/providers/featureFlagsProvider';
import { useCallback, useContext } from 'react';

export const useFeatureFlags = (): FeatureFlagsContextType & {
  canUseFeature: (feature: string) => boolean;
} => {
  const context = useContext(FeatureFlagsContext) as FeatureFlagsContextType;

  const featureFlagsEnabled = process.env.REACT_APP_FEATURE_TOGGLE_ENABLED;

  if (!context) {
    throw new Error(
      'useFeatureFlags must be used within a FeatureFlagsProvider',
    );
  }

  const { featureFlags, featureFlagsStatus } = context;

  const canUseFeature = useCallback(
    (feature: string) => {
      if (
        featureFlagsEnabled === 'true' &&
        featureFlagsStatus === 'COMPLETED'
      ) {
        return context.featureFlags.includes?.(feature);
      }
      return true;
    },
    [context, featureFlagsEnabled, featureFlagsStatus],
  );

  return { featureFlags, featureFlagsStatus, canUseFeature };
};
